import uuidv4 from 'uuid/dist/v4'
function replaceDialCode(phone) {
  let re = /(\+\d*\s)(\w.*)/
  let payload = {
    phone: undefined,
    dialCode: undefined,
  }
  payload.phone = phone.replace(re, ($0, $1, $2) => {
    //记录下购物车中存的dialCode
    payload.dialCode = $1.replace(/[\D]/g, '')
    return $2
  })
  return payload
}
function downloadFile(url, fileName) {
  var x = new XMLHttpRequest()
  x.open('GET', url, true)
  x.responseType = 'blob'
  x.onload = function (e) {
    var url = window.URL.createObjectURL(x.response)
    var a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()
  }
  x.send()
}
function custom_format(validValue, blocks, delimiters) {
  //  validValue = 12345678912345;
  //  blocks = [2, 5, 8, 12];
  //  delimiters = ['.', '.', '/', '-'];
  let offsets = [].concat(0, blocks, validValue.length)
  let splitValue = []
  // 此步骤会把 validValue 按照blocks切分为[12,345,678,9123,45];
  for (let i = 0; offsets[i] < validValue.length; i++) {
    let start = offsets[i]
    let end = Math.min(offsets[i + 1], validValue.length)
    splitValue.push(validValue.substring(start, end))
  }
  //此步骤按照 delimiters规则，拼接为["12.","345.","678/","9123-",45];
  let awaitJoinValue = splitValue.map((item, index) => {
    // 注意 splitValue 有下一项的时候才会拼接上;
    if (delimiters?.length && delimiters[index] && splitValue[index + 1]) {
      return item + delimiters[index]
    } else {
      return item
    }
  })
  return awaitJoinValue.join('')
}

function loadScript(src, callback, errorback) {
  var script = document.createElement('script'),
    head = document.getElementsByTagName('head')[0]
  script.type = 'text/javascript'
  script.src = src
  if (script.addEventListener) {
    script.addEventListener('load', callback, false)
    if (errorback) {
      script.addEventListener('error', errorback, false)
    }
  } else if (script.attachEvent) {
    script.attachEvent('onreadystatechange', function () {
      var target = window.event.srcElement
      if (target.readyState == 'loaded') {
        callback()
      }
    })
  }
  head.appendChild(script)
}

function randomCoding(n = 4) {
  var result = []
  for (var i = 0; i < n; i++) {
    //生成一个0到25的数字
    var ranNum = Math.ceil(Math.random() * 25)
    //大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;
    //然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
    result.push(String.fromCharCode(65 + ranNum))
  }
  return result.join('')
}
const uniqueKey = (payload = []) => {
  return payload.join(',')
}
const accumulator_height = (el_list = []) => {
  let arrts = ['fixed', 'sticky']
  let num = 0
  el_list.forEach((item) => {
    let el = $(item)
    if (arrts.includes(el.css('position'))) {
      num += el.height()
    }
  })
  return num
}
const isParent = (target, el) => {
  if (target.parentNode === el) return true
  if (!target.parentNode || target.parentNode.localName === 'html') return false
  return isParent(target.parentNode, el)
}
window.send_fb_event = (name, payload) => {
  if (!window.fbq) return
  let uuid = uuidv4()
  for (const key in payload) {
    if (payload[key] && typeof payload[key] != 'string') {
      payload[key] = JSON.stringify(payload[key])
    }
  }
  if (!window.blockPixel || (!getCookie('_fbp') && name === 'PageView')) {
    window.fbq('track', name, { ...payload }, { eventID: uuid })
  }
  if (!window.PixelConversion) return //没开多像素不继续执行
  let copy_payload = {
    event_name: name,
    fbp: getCookie('_fbp'),
    fbc: getCookie('_fbc'),
    event_source_url: window.location.href,
    event_id: uuid,
  }
  if (window.pixel_ids && Array.isArray(window.pixel_ids)) copy_payload.pixel_ids = window.pixel_ids.join(',')
  if (window.error_page != 404) {
    axios.post('/api/store/facebook-conversions-api', { ...payload, ...copy_payload })
  }
}
window.send_ttp_event = (name, payload) => {
  if (!window.ttq) return
  window.ttq.identify({
    email: localStorage.getItem('email') ?? '',
    phone_number: localStorage.getItem('phone') ?? '',
  });
  window.ttq.track(name, payload)
}

Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, //月份
    'd+': this.getDate(), //日
    'h+': this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, //小时
    'H+': this.getHours(), //小时
    'm+': this.getMinutes(), //分
    's+': this.getSeconds(), //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
  return fmt
}

//事件防抖
const debounce = function (fn, delay = 200) {
  let timer = null
  return function () {
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, arguments)
    }, delay)
  }
}

const setObjSeach = (obj) => {
  // 将对象转换成search形式，配合formatSearch函数实现互转;
  let search = '?'
  for (const key in obj) {
    search += `&${key}=${obj[key]}`
  }
  return search
}

const cart_notices = (cart, _this) => {
  if (cart && cart.notices && cart.notices.length && _this && _this.$message && _this.$message.error) {
    cart.notices.forEach((item, index) => {
      _this.$message({
        showClose: true,
        message: item,
        type: 'error',
        duration: 0,
        offset: 60 * (index + 1),
      })
    })
  }
}

const copyToClip = (text) => {
  const input = document.createElement('input')
  input.setAttribute('readonly', 'readonly')
  input.setAttribute('value', text)
  document.body.appendChild(input)
  input.select()
  if (document.execCommand('Copy')) {
    document.execCommand('Copy')
  }
  document.body.removeChild(input)
}

const re_remover_class = (text) => {
  if (typeof text !== 'string') return text

  const re = /\sclass=['|"]([^'"]+)['|"]/g
  return text.replace(re, ' ')
}

const translate = (message, _this) => {
  let res = message
  if (!message || !_this) return res
  switch (message.toLowerCase().trim()) {
    case 'about us':
      return _this.$t('policy.about-us')
    case 'contact us':
      return _this.$t('policy.contact-us')
    case 'refund policy':
      return _this.$t('policy.refund-policy')
    case 'shipping policy':
      return _this.$t('policy.shipping-policy')
    case 'privacy policy':
      return _this.$t('policy.privacy-policy')
    case 'terms of service':
      return _this.$t('policy.terms-of-service')
    case 'all collections':
      return _this.$t('venue.productList.all_collections')
    case 'home':
      return _this.$t('home.home')
    case 'search':
      return _this.$t('venue.home.search')
    case 'search':
      return _this.$t('venue.home.search')
    default:
      return res
  }
}
const filterinputnum = (event, min = 1) => {
  if (!event) return 0
  let val = event
    .toString()
    .replace(/[^\d^\.]+/g, '')
    .replace('.', '$#$')
    .replace(/\./g, '')
    .replace('$#$', '.')
  if (val === '') {
    val = 1
    if (val < min) val = min
  } else if (val > 0) {
    val = Math.round(val)
  }
  return Number(val)
}

const toCheckInfo = (cart_hash) => {
  if (cart_hash) {
    location.href = `/checkouts/${cart_hash}`
  } else {
    location.href = `/checkouts?step=contact_information`
  }
}
const formatSearch = ({ search } = window.location) => {
  if (search && search.length) {
    search = search.substr(1)
    let arr = search.split('&'),
      obj = {},
      newarr = []
    arr.forEach((v) => {
      if (!v) return
      newarr = v.split('=')
      if (typeof obj[newarr[0]] === 'undefined') {
        obj[newarr[0]] = newarr[1]
      }
    })
    return obj
  } else {
    return {}
  }
}
const replaceSearch = (name, value, onlySearch) => {
  //有第三个参数则仅返回查询参数格式，否者返回完整路径
  let location = window.location
  let newhref = null
  const re = new RegExp(name + '=[^&]*', 'gi')
  if (location.search && re.test(location.search)) {
    newhref = location.search.replace(re, name + '=' + value)
  } else if (location.search) {
    newhref = location.search + `&${name}=${value}`
  } else {
    newhref = `?${name}=${value}`
  }
  return onlySearch ? newhref : location.pathname + newhref
}
window.getCookie = (key) => {
  let cookie = document.cookie
  let value = null
  if (cookie) {
    let cookie_arr = cookie.split(';')
    cookie_arr.some((item) => {
      if (item.includes(key)) {
        let item_arr = item.split('=')
        if ((item_arr.length = 2)) {
          value = item_arr[1]
          return true
        }
      }
    })
  }
  return value
}
// 获取查询参数,接收参数作为变量，返回参数=号后的值
const getSearch = (search) => {
  let search_data = window.location.search
  let res = null
  if (search_data && search_data.split('?').length) {
    search_data
      .split('?')[1]
      .split('&')
      .some((item) => {
        if (item.includes(search)) {
          res = item.split('=')[1]
          return true
        }
      })
  }
  return res
}
// 拼接国家，部分国家需要替换省份时使用。
const concatCounty = (service, newCountry) => {
  newCountry.forEach((item) => {
    service.some((serviceItem) => {
      if (item.iso2 == serviceItem.code) {
        serviceItem.states = []
        item.states.forEach((element) => {
          serviceItem.states.push({
            name: element.name,
            code: element.name,
          })
        })
        return true
      }
    })
  })
  return service
}
//展示货币格式
const computePrice = (num, disable_select, country, places, thousand, decimal) => {
  // disable_select禁止选择为true时候应直接使用传入的价格，
  // 但禁止选择为true并且传入国家时候应该乘这个国家的汇率
  if (!disable_select) {
    num = store.state.rates[store.state.pricetype] * num
  } else if (country) {
    num = store.state.rates[country] * num
  }

  num = num || 0
  if (
    (store.state.pricetype == 'JPY' && !disable_select) ||
    (disable_select && (window.checkoutcurrency == 'JPY' || country == 'JPY'))
  ) {
    places = 0
  }
  if (places === 'auto' && (num | 0) === num) {
    places = 0
  } else {
    places = !isNaN((places = Math.abs(places))) ? places : 2
  }
  thousand = thousand || ','
  decimal = decimal || '.'
  var negative = num < 0 ? '-' : '',
    i = parseInt((num = Math.abs(+num || 0).toFixed(places)), 10) + '',
    a = 0,
    j = (a = i.length) > 3 ? a % 3 : 0
  return (
    negative +
    (j ? i.substr(0, j) + thousand : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) +
    (places
      ? decimal +
        Math.abs(num - i)
          .toFixed(places)
          .slice(2)
      : '')
  )
}

const initFBevent = (pixel_conversion, product_category_ids) => {
  pixel_conversion.forEach((item) => {
    if (item.type == 'category' && product_category_ids.includes(parseInt(item.category_id))) {
      if (window.pixel_ids && Array.isArray(window.pixel_ids)) {
        window.pixel_ids.push(item.pixel_id)
      } else {
        window.pixel_ids = [item.pixel_id]
      }
      // fbq("init", item.pixel_id);
      // fbq("track", "PageView");
    }
  })
}
const FBevent = () => {
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
}
const FbAddToCart = function (product, addproduct) {
  let content_category = []
  let currency = window.checkoutcurrency
  if (product.categories && product.categories.length) {
    product.categories.forEach((item) => {
      content_category.push(item.name)
    })
  }
  window.fbq('track', 'AddToCart', {
    content_type: 'product_group',
    content_ids: [addproduct.product_id],
    value: product.price,
    num_items: addproduct.quantity,
    content_name: product.title,
    currency,
    content_category,
  })
}

export const klaviyo_addtocart = function (product, addproduct) {
  const { product_id, quantity, variant_id } = addproduct
  let content_category = []
  if (product.categories && product.categories.length) {
    product.categories.forEach((item) => {
      content_category.push(item.name)
    })
  }
  let current_product = {}
  if (variant_id && (product.variants || product.variants_detail)) {
    if (product.variants) {
      product.variants.forEach((item) => {
        if (item.ID == variant_id) {
          current_product = item
        }
      })
    } else {
      product.variants_detail.forEach((item) => {
        if (item.ID == variant_id) {
          current_product = item
        }
      })
    }
  } else {
    current_product = product
  }
  window._learnq.push([
    'track',
    'Added to Cart',
    {
      AddedItemProductName: product.title,
      AddedItemProductID: variant_id || product_id,
      AddedItemSKU: current_product.sku,
      AddedItemCategories: content_category,
      AddedItemImageURL: current_product.image ? current_product.image : null,
      AddedItemURL: product.public_url,
      AddedItemPrice: current_product.price,
      AddedItemQuantity: quantity,
    },
  ])
}

const klaviyo_checkout = function (cart_item) {
  const { hash, cart_total, cart } = cart_item
  let items = []
  let name = []
  Object.values(cart).forEach((item) => {
    const obj = {
      ProductID: item.product.ID,
      SKU: item.product.sku,
      ProductName: item.product.post_title,
      Quantity: item.quantity,
      ItemPrice: item.product.price,
      RowTotal: item.line_total,
      ProductURL: item.product.public_url ? item.product.public_url : null,
      ImageURL: (item.product.feature_image && item.product.feature_image.url) || null,
      // "ProductCategories": ["Fiction", "Children"]
    }
    name.push(item.product.post_title)
    items.push(obj)
  })
  window._learnq.push([
    'track',
    'Started Checkout',
    {
      $event_id: hash,
      $value: cart_total,
      ItemNames: name,
      // "Categories": ["Fiction", "Children", "Classics"],
      Items: items,
    },
  ])
}
const getcountry = function (country, service) {
  let name = null
  service.some((item) => {
    if (item.code == country) {
      name = item.name
      return true
    }
  })
  return name
}
const getstate = function (state, country, service) {
  let province = null
  service.some((item) => {
    if (item.code == country) {
      item.states.some((subitem) => {
        if (state == subitem.code) {
          province = subitem.name
          return true
        }
      })
      return true
    }
  })
  return province
}
const imageFailure = function (e, defaultImage) {
  e.target.src = defaultImage
  e.target.srcset = defaultImage
}

export default {
  custom_format,
  toCheckInfo,
  FbAddToCart,
  replaceSearch,
  getCookie,
  getSearch,
  computePrice,
  initFBevent,
  FBevent,
  getcountry,
  getstate,
  imageFailure,
  concatCounty,
  filterinputnum,
  translate,
  formatSearch,
  re_remover_class,
  copyToClip,
  cart_notices,
  klaviyo_addtocart,
  klaviyo_checkout,
  setObjSeach,
  debounce,
  send_fb_event,
  isParent,
  accumulator_height,
  uniqueKey,
  randomCoding,
  loadScript,
  downloadFile,
  send_ttp_event,
  replaceDialCode,
}
